import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from './auth';
import { fetchMinhasPermissoes } from '../../api/permissoesSidebar';

const PermissoesSidebarContext = React.createContext({
  permissoes: null,
  loading: true,
  refetch: () => {},
});

function PermissoesSidebarProvider(props) {
  const { logado } = useContext(AuthContext);
  const [permissoes, setPermissoes] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = React.useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!logado || !token) {
      setPermissoes(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    const data = await fetchMinhasPermissoes();
    setPermissoes(data);
    setLoading(false);
  }, [logado]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (!logado) return;
    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        load();
      }
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, [logado, load]);

  const value = { permissoes, loading, refetch: load };

  return (
    <PermissoesSidebarContext.Provider value={value}>
      {props.children}
    </PermissoesSidebarContext.Provider>
  );
}

export { PermissoesSidebarContext, PermissoesSidebarProvider };
